module.exports = __webpack_public_path__ + "img/img_view_direct_kt_02.450b31bf.png";